import { put, takeEvery, takeLatest, select } from 'redux-saga/effects';

import CustomerInformations from '../../../models/CustomerInformations';

import { SALESFORCE_DATA_READY } from '../SFDataService/actions';
import { CUSTOMER_INFORMATIONS_SAVED } from './actions';

import * as Actions from './actions';

export function* populateCustomerInformations(action) {
  let informations = yield select(state => state.customerInformations);
  if (action.account !== null && action.opportunity !== null) {
    if (informations === null || informations === {}) {
      informations = new CustomerInformations(
        action.account.getId(),
        action.opportunity.getName(),
        action.account.getTypoCategory(),
        action.account.getTypoType(),
        action.account.getPhone(),
      );
    } else {
      informations = informations
        .clone()
        .setId(action.account._id)
        .setName(action.opportunity._name)
        .setTypoCategory(action.account._typo_category)
        .setTypoType(action.account._typo_type)
        .setPhone(action.account._phone);
    }
  }
  yield put(Actions.customerInformationsUpdated(informations));
}

export function* savedCustomerInformations(action) {
  let informations = new CustomerInformations()
    .setId(action.values.id)
    .setName(action.values.name)
    .setPhone(action.values.phone)
    .setTypoCategory(action.values.typo_category)
    .setTypoType(action.values.typo_type);

  yield put(Actions.customerInformationsDataReady(informations));
}

export function* customerInformationsListener() {
  yield takeLatest(SALESFORCE_DATA_READY, populateCustomerInformations);
  yield takeEvery(CUSTOMER_INFORMATIONS_SAVED, savedCustomerInformations);
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerInformationService/saga.js